/**
 * GENERATED by scripts/generate-brand-icons.mjs from src/design/pavilion/markGeometry.ts and
 * config/design-tokens.json — do not edit. Every page that shows the logo as an image reads its address here.
 *
 * The drop-in marks sit on the old raster's own 545 x 512 canvas with the ring where the old orb was, so an <img>
 * tuned for the old file needs no CSS change. The query is the file's own content hash: a changed mark is a new
 * address, never a 30-day-cached old one.
 */
/** The mark with charcoal ink, for a light ground. */
export const BRAND_MARK_SRC = '/images/prest0-mark.svg?v=2a5bdb3d89';
/** The mark with cream ink, for a dark ground. */
export const BRAND_MARK_ON_DARK_SRC = '/images/prest0-mark-on-dark.svg?v=3fc182ab19';
/** The link-preview image (1200 x 630). */
export const BRAND_SHARE_IMAGE_URL = 'https://prest0.ai/images/prest0-share.png?v=358eec63a4';
/** The square logo search engines show (512 x 512, on the day's canvas). */
export const BRAND_LOGO_URL = 'https://prest0.ai/favicon-mark-512.png';
/** A notification's icon, and its badge (a transparent silhouette: the launcher uses its alpha only). */
export const BRAND_NOTIFICATION_ICON = '/favicon-mark-192.png';
export const BRAND_NOTIFICATION_BADGE = '/favicon-mark-badge-96.png';
